// extracted by mini-css-extract-plugin
export default {"downloads":"DownloadLinks_downloads__nZlga","formats":"DownloadLinks_formats__DDmkx"};